module.exports = __webpack_public_path__ + "img/video_retrogress.f2a7e364.svg";